import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const user = {
  state: {
    user_tutor: {},
    tutor_location: {},
    sidebar_visible: false,
    navbar_visible: true,
  },
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/user/store.js